import type {
	FailoverEventsDto,
	FailoverHealthDto,
} from "@/types/ai-assistant-failover-health";
import { request } from "./ai-assistant.api";

/** Lencana status penyedia, spanduk biaya, dan peringatan suara dari server. */
export function fetchFailoverHealth(
	signal?: AbortSignal,
): Promise<FailoverHealthDto> {
	return request<FailoverHealthDto>(
		"/failover/health",
		{ signal },
		"Memuat status penyedia",
	);
}

/** Satu halaman riwayat pindah ke Cadangan (30 hari, terbaru dulu). */
export function fetchFailoverEvents(
	cursor?: string,
	signal?: AbortSignal,
): Promise<FailoverEventsDto> {
	const qs = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
	return request<FailoverEventsDto>(
		`/failover/events${qs}`,
		{ signal },
		"Memuat riwayat pindah",
	);
}
